import dayjs from "dayjs";

/**
 * /地推、邀请有礼归因所需参数工具Utils，存储7天
 */

// Default key name
export const EXT_KEY = "urlExtraParams";
// Default timeout: Unit: days
export const EXPIRE_DAYS = 7; //默认存储7天

// 初始化缓存中的地址
export const saveUrlExtraParams = () => {
  const params = new URLSearchParams(window.location.search);
  if (!params) return {};
  // 检查是否包含以 'ext_' 开头的参数
  const extParamsExist = Array.from(params.keys()).some(key => key.startsWith('ext_'));
  if (!extParamsExist) return; // 如果没有，直接返回
  const extUrlParams: { [key: string]: string } = {};
  params.forEach((value, key) => {
    if (key.startsWith('ext_')) {
      const newKey = key.substring(4);
      extUrlParams[newKey] = value;
    }
  });
  const date = dayjs(new Date());
  // 格式化时间
  const currentDate = date.format("YYYY-MM-DD"); // YYYY-MM-DD
  localStorage.setItem(EXT_KEY, JSON.stringify({ date: currentDate, extUrlParams: extUrlParams }));
};

export const getUrlExtraParams = () => {
  // 获取当前日期
  const date = dayjs(new Date());
  // 格式化时间
  const extraParams = localStorage.getItem(EXT_KEY);
  if (!extraParams) {
    return {};
  }
  const lastShown = JSON.parse(extraParams);
  // 计算存储的日期与当前日期之间的天数差
  const storedDate = dayjs(lastShown.date);
  const daysDiff = date.diff(storedDate, 'day');
  // 如果日期相同或在7天内，返回参数
  if (daysDiff <= EXPIRE_DAYS) {
    return lastShown.extUrlParams;
  }
  // 大于7天需要清除存储的参数
  clearUrlExtraParams();
  return {};
};

export const clearUrlExtraParams = () => {
  // 清除存储的参数
  localStorage.removeItem(EXT_KEY);
};
